<template>
    <div id="features" class="mb-6">
        <div class="bg-grey-lightest">
            <div class="container mx-auto px-6 pt-24">
                <h1 class="text-center text-black font-semibold text-2xl">
                    App Features
                </h1>
                <div
                    class="flex md:flex-no-wrap xs:flex-wrap justify-center mt-24"
                >
                    <div class="flex-1 px-6 py-6 m-2 text-center">
                        <img
                            src="./../assets/medicine.svg"
                            alt="medication image"
                            class="h-16 mb-4"
                        />
                        <h3 class="mb-4">Medication</h3>
                        <p class="text-black font-base text-sm opacity-50">
                            Medication Tracking: Easily keep track of your medication intake, ensuring timely doses and adherence to prescriptions.
                        </p>
                    </div>
                    <div class="flex-1 px-6 py-6 m-2 text-center">
                        <img
                            src="./../assets/indicator.svg"
                            alt="indicator image"
                            class="h-16 mb-4"
                        />
                        <h3 class="mb-4">Indicators</h3>
                        <p class="text-black font-base text-sm opacity-50">
                            Vital Signs Monitoring: Monitor crucial vital signs such as height, weight, body temperature, blood glucose levels, heart rate, and blood pressure, empowering you to stay in control of your health.
                        </p>
                    </div>
                    <div class="flex-1 px-6 py-6 m-2 text-center">
                        <img
                            src="./../assets/notebook.svg"
                            alt="notebook image"
                            class="h-16 mb-4"
                        />
                        <h3 class="mb-4">Health notebook</h3>
                        <p class="text-black font-base text-sm opacity-50">
                            Disease Treatment Progress: Track and record the treatment progress of your diseases, allowing you to monitor and manage your journey towards recovery.
                        </p>
                    </div>
                </div>
                <div
                    class="flex md:flex-no-wrap xs:flex-wrap items-center justify-center lg:mt-12 xs:mt-0"
                >
                    <div class="flex-1">
                        <div class="px-12 py-12 m-4 text-center">
                            <img
                                src="./../assets/exam.svg"
                                alt="exam image"
                                class="h-16 mb-4"
                            />
                            <h3 class="mb-4">Examination</h3>
                            <p class="text-black font-thin text-xs opacity-50">
                                Medical Checkup Records: Conveniently record your medical checkup results, including reports, diagnoses, and recommendations.
                            </p>
                        </div>
                        <div class="px-12 py-12 m-4 text-center">
                            <img
                                src="./../assets/vaccine.svg"
                                alt="vaccination image"
                                class="h-16 mb-4"
                            />
                            <h3 class="mb-4">Vaccination</h3>
                            <p class="text-black font-thin text-xs opacity-50">
                                Vaccination History: Keep a record of your vaccination history as well as that of your family members, ensuring timely vaccinations and access to vaccination records.
                            </p>
                        </div>
                    </div>
                    <div class="xs:hidden lg:block md:flex-2 lg:flex-2">
                        <img
                            src="./../assets/iphone.png"
                            alt="iphone image"
                            class="h-iphone"
                        />
                    </div>
                    <div class="flex-1">
                        <div class="px-12 py-12 m-4 text-center">
                            <img
                                src="./../assets/feeling.svg"
                                alt="feeling image"
                                class="h-16 mb-4"
                            />
                            <h3 class="mb-4">Feeling</h3>
                            <p class="text-black font-thin text-xs opacity-50">
                                Mood Tracking: Record changes in your mood, helping you understand patterns and trends in your emotional well-being.
                            </p>
                        </div>
                        <div class="px-12 py-12 m-4 text-center">
                            <img
                                src="./../assets/privacy.svg"
                                alt="privacy image"
                                class="h-16 mb-4"
                            />
                            <h3 class="mb-4">Privacy</h3>
                            <p class="text-black font-thin text-xs opacity-50">
                                Offline Data Storage: All data is securely stored offline on your device, with no involvement of servers, ensuring the utmost privacy protection.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    class="flex md:flex-no-wrap xs:flex-wrap justify-center mt-12"
                >
                    <div class="flex-1 px-6 py-6 m-2 text-center">
                        <img
                            src="./../assets/period.svg"
                            alt="period image"
                            class="h-16 mb-4"
                        />
                        <h3 class="mb-4">Period</h3>
                        <p class="text-black font-base text-sm opacity-50">
                            Women's Health: Women users can track menstrual cycles and related symptoms, providing insights into and better management of women's health.
                        </p>
                    </div>
                    <div class="flex-1 px-6 py-6 m-2 text-center">
                        <img
                            src="./../assets/transgender.svg"
                            alt="transgender image"
                            class="h-16 mb-4"
                        />
                        <h3 class="mb-4">Transgender</h3>
                        <p class="text-black font-base text-sm opacity-50">
                            Transgender Medication and Hormone Tracking: Tailored specifically for transgender individuals, track medication intake and hormone changes to better manage your health.
                        </p>
                    </div>
                    <div class="flex-1 px-6 py-6 m-2 text-center">
                        <img
                            src="./../assets/develop.svg"
                            alt="develop image"
                            class="h-16 mb-4"
                        />
                        <h3 class="mb-4">More</h3>
                        <p class="text-black font-base text-sm opacity-50">
                            Continuous Development: We are continuously developing new features to meet your personalized needs and enhance your user experience.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <svg
            id="curveDownColor"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="100%"
            height="100"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
        >
            <path style="fill: #f8fafc" d="M0 0 C 50 100 80 100 100 0 Z" />
        </svg>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
